import { api } from 'shared/sdk';
import { asyncValidatePromiseWrapper } from 'shared/forms/asyncValidators';

export const asyncValidate = (values, dispatch, props, field) => {
  if (field === 'email') {
    return asyncValidatePromiseWrapper(
      api.validateEmail,
      { requestBody: { email: values.email } },
      props.asyncErrors
    );
  }

  if (field === 'password') {
    return asyncValidatePromiseWrapper(
      api.validatePassword,
      { requestBody: { password: values.password } },
      props.asyncErrors
    );
  }

  return new Promise(function(resolve) {
    resolve();
  });
};
